import { Box, Flex, useDisclosure } from "@chakra-ui/react";
import React from "react";
import { FiChevronsLeft, FiChevronsRight } from "react-icons/fi";

import { GmnFilterCheckboxes } from "../../../../gmn/components/gmn-filter-checkboxes";
import { useGmwContext } from "../../../contexts/gmw-context";

const GmnFilterLegend: React.FC = () => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: true });
  const { gmwFilters, setGmwFiltersByGMN } = useGmwContext();

  return (
    <Flex
      roundedTopRight="md"
      flexDir="column"
      bg="white"
      py="1"
      px="3"
      zIndex={1002}
      pos="absolute"
      bottom="0"
      w="200px"
      transition="0.5s all"
      left={isOpen ? "0" : "-200px"}
      maxH="full"
    >
      <Box maxH="full" overflowY="auto">
        <Box h="fit-content">
          <GmnFilterCheckboxes filters={gmwFilters} setFilters={setGmwFiltersByGMN} />
        </Box>
      </Box>
      <Flex
        roundedTopRight="md"
        pos="absolute"
        bottom="0"
        left="100%"
        bg="white"
        cursor="pointer"
        onClick={onToggle}
      >
        {isOpen ? <FiChevronsLeft size="25" /> : <FiChevronsRight size="25" />}
      </Flex>
    </Flex>
  );
};

export { GmnFilterLegend };
